<div class="loans-widget" (click)="openModal()">
  <!-- Header -->
  <div class="loans-header">
    <div class="loans-title">{{ title }}</div>

    <ng-container *ngIf="isEditMode">
      <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()" cdkOverlayOrigin
        #editTrigger="cdkOverlayOrigin">
        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
      </div>
      <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
        [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
        [toggleSizeDropdown]="toggleSizeDropdown">
      </app-widget-edit>
    </ng-container>

    <ng-container *ngIf="isAddMode">
      <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Add"
        (click)="addWidget.emit(); $event.stopPropagation()" />
    </ng-container>
  </div>

  <!-- Content -->
  <div class="loans-main">
    <ng-container [ngSwitch]="size">

      <!-- SMALL -->
      <ng-container *ngSwitchCase="'small'">
        <div class="small-total">
          Total loan:
          <div class="amount">₹{{ loan.total | number:'1.0-0' }}</div>
        </div>

        <div class="emi-row mt-0">
          <div class="emi-details">
            <div class="emi-label">EMI:</div>
            <div class="emi-value">
              <span class="amount">₹ {{ loan.emi | number:'1.0-0' }}</span>
              <span class="period"> / week</span>
            </div>
          </div>
        </div>

        <div class="progress-container small">
          <div class="progress-fill" [style.width.%]="loan.paidPercent"></div>
        </div>
        <div class="paid-status">Paid {{ loan.paidPercent }}%</div>
      </ng-container>

      <!-- MEDIUM (default) -->
      <ng-container *ngSwitchDefault>
        <div class="medium-totals">
          <div class="remaining">
            <div class="label">REMAINING</div>
            <div class="value">₹{{ remaining | number:'1.2-2' }}</div>
          </div>
          <div class="total">
            <div class="label">TOTAL LOAN</div>
            <div class="value">₹{{ loan.total | number:'1.2-2' }}</div>
          </div>
        </div>

        <div class="emi-row">
          <div class="emi-details">
            <div class="emi-label">EMI:</div>
            <div class="emi-value">
              <span class="amount">₹ {{ loan.emi | number:'1.0-0' }}</span>
              <span class="period"> / week</span>
            </div>
          </div>
          <div class="paid-status">Paid {{ loan.paidPercent }}%</div>
        </div>

        <div class="progress-container medium">
          <div class="progress-fill" [style.width.%]="loan.paidPercent"></div>
        </div>
      </ng-container>

    </ng-container>
  </div>
</div>